<template>
<div>Zielgruppen
</div>
</template>

<script>
export default {
  name: "Briefe",

}
</script>

<style scoped>

</style>
